import { Component, Vue } from 'vue-property-decorator';

import { BioLockupBlockViewModel } from './BioLockupModule.types';
import { getComponentProps } from '@/utils/vueUtils';
import { ImageSizes, ImageSize } from '@/common/interfaces/SizeBreakpoints';

import ResponsiveImage from '@/components/ResponsiveImage/ResponsiveImage.vue';
import TitleIconComponent from '@/components/TitleIcon/TitleIcon.vue';
import Arrow from '@/assets/icons/arrow.svg?inline';
import { getResizeImage } from '@/utils/commonUtils';

const BioLockupModuleProps = Vue.extend({
  props: getComponentProps<BioLockupBlockViewModel>({
    Image: { Url: getResizeImage('captain-kruess.jpg'), Alt: 'Kreuss' },
    Name: 'Alexandra Widman',
    Text: `<p>Alexandra grew up on the southeast coast of the United States. She has a deep love for the ocean that stems from her childhood spent surfing, kayaking, diving and fishing on the Intracoastal Waterway. Alexandra has lived on San Cristóbal Island for the past 6 years, having fallen in love with Galápagos the moment she arrived as a fledgling marine ecologist. She holds a bachelor’s degree in marine biology and a master’s in environmental science and management from the University of California Santa Barbara.</p><br><p>She worked for the Charles Darwin Marine Research Station on a shark conservation project, focusing on the economic importance of sharks for marine tourism. She worked with National Geographic’s Pristine Seas to help create the Darwin and Wolf Marine Sanctuary of Galapagos in 2016, protecting the largest aggregation of sharks in the world. As a naturalist guide, Alexandra loves to share all of the unique marine marvels of Galápagos with visitors in order to spark a greater awareness on the importance of conserving our precious oceans; both in Galápagos and throughout the rest of the world.</p>`,
    Link: '#',
    TitleIcon: {
      Title: 'Naturalist',
      Path: '',
    }
  }),
});
@Component({
  components: {
    ResponsiveImage,
    TitleIcon: TitleIconComponent,
    Arrow,
  },
})
export default class BioLockupModule extends BioLockupModuleProps {
  ImageSizesThumbnail: ImageSizes = {
    def: new ImageSize([150, 150]),
    sizes: {
      md: new ImageSize([150, 150]),
    },
  };
  onBackClick() {
    if (document.referrer && document.referrer.includes(window.location.host) && document.referrer !== document.location.href) {
      window.history.back()
    } else {
      window.open(this.p.Link, '_self')
    }
  }
}
